// ─── Fases da Cadência ──────────────────────────────────────────────────────

/** Cores de fase: texto forte no badge; progress suave na barra */
export const faseInfo: Record<
  number,
  {
    label: string
    color: string
    bar: string
    fill: string
    text: string
    border: string
    progress: string
  }
> = {
  1: {
    label: 'F1 Abertura de Fluxo',
    color: '#0d9488',
    bar: '#0d9488',
    fill: '#ccfbf1',
    text: '#134e4a',
    border: '#0f766e',
    progress: '#5eead4',
  },
  2: {
    label: 'F2 Conexão Ativa',
    color: '#059669',
    bar: '#059669',
    fill: '#d1fae5',
    text: '#14532d',
    border: '#047857',
    progress: '#6ee7b7',
  },
  3: {
    label: 'F3 Follow-up / Maturação',
    color: '#d97706',
    bar: '#d97706',
    fill: '#fef3c7',
    text: '#78350f',
    border: '#b45309',
    progress: '#fcd34d',
  },
  4: {
    label: 'F4 Fechamento / Handoff',
    color: '#dc2626',
    bar: '#dc2626',
    fill: '#fee2e2',
    text: '#7f1d1d',
    border: '#b91c1c',
    progress: '#fca5a5',
  },
}

export const resultadosTentativa = [
  'Sem Sucesso',
  'Agenda Reunião (F1)',
  'Follow-up Agendado',
  'Perda de Interesse',
  'Número Inexistente',
  'Lead Ocupado',
  'Reunião Agendada',
]

export const canais = ['Telefone', 'WhatsApp', 'Email', 'Presencial', 'Outro']

/** Badge Decisor — cores fixas (evita dark: do OS sobrescrever no tema claro) */
export const decisorBadge = {
  light: { bg: '#dcfce7', text: '#14532d', border: '#15803d' },
  dark: { bg: '#166534', text: '#ecfdf5', border: '#4ade80' },
} as const

/** Superfícies e labels — contraste alto no tema claro */
export const panelSurface =
  'rounded-2xl border-2 border-zinc-200 bg-white shadow-md dark:border-[color:var(--border)] dark:bg-[var(--bg-card)] dark:shadow-sm'
export const insetSurface =
  'rounded-xl border-2 border-zinc-300 bg-zinc-100 dark:border-[color:var(--border)] dark:bg-[color-mix(in_srgb,var(--text-primary)_5%,var(--bg-main))]'
export const labelCaps =
  'text-[11px] font-black uppercase tracking-wider text-zinc-800 dark:text-text-secondary'
export const bodyMuted = 'text-zinc-700 dark:text-text-secondary'
export const fieldControl =
  'w-full rounded-lg border-2 border-zinc-300 bg-white text-zinc-900 placeholder:text-zinc-500 px-3 py-2.5 text-sm font-medium outline-none focus:border-accent focus:ring-2 focus:ring-accent/30 transition-colors min-h-[44px] dark:border-[color:var(--border)] dark:bg-[var(--bg-card)] dark:text-text-primary dark:placeholder:text-text-muted'

export const actionTones = {
  teal:
    'text-teal-950 bg-teal-100 border-2 border-teal-700 hover:bg-teal-200 shadow-sm dark:text-teal-50 dark:bg-teal-800 dark:border-teal-500 dark:hover:bg-teal-700',
  accent:
    'text-indigo-950 bg-indigo-100 border-2 border-indigo-700 hover:bg-indigo-200 shadow-sm dark:text-white dark:bg-indigo-700 dark:border-indigo-500 dark:hover:bg-indigo-600',
  green:
    'text-green-950 bg-green-100 border-2 border-green-700 hover:bg-green-200 shadow-sm dark:text-green-50 dark:bg-green-800 dark:border-green-600 dark:hover:bg-green-700',
  red:
    'text-red-950 bg-red-100 border-2 border-red-700 hover:bg-red-200 shadow-sm dark:text-red-50 dark:bg-red-900/80 dark:border-red-600 dark:hover:bg-red-800',
} as const
